import React from "react";
import {motion} from "framer-motion";
import styled from "styled-components";
import {
    mediaLaptop,
    mediaTablet,
    mediaUnderTablet,
    mediaMaxWidthMobile,
    mediaMobile,
    mediaUnderTabletQuery,
} from "src/styles/mediaQuery";
import {
    Section as OriginalSection,
    Inner,
    LinePoint,
    SubLine,
    TitleLine, LineBreak, VideoWrapper, BackgroundVideo
} from "src/styles/common/sectionStyles";
import {FeedSectionVideoProps} from "src/pages/section/FeedSection/index";

const textContainerVariants = {
    initial: {
        opacity: 0,
        y: 45
    },
    animate: {
        opacity: 1,
        y: 0,
        transition: {
            duration: .5,
            delay:.5,
        }
    },

};
const videoContainerVariants = {
    initial: {
        opacity: 0,
    },
    animate: {
        opacity: 1,
        transition: {
            duration: .5,
            delay:.5,
        }
    },

};

function FeedSectionView({tabletVideoSrc,defaultVideoSrc}:FeedSectionVideoProps) {
    return (
        <Section className="section">
            <Inner>
                <ContentsWrap>
                    <Contents
                        variants={textContainerVariants}
                        initial="initial"
                        whileInView="animate"
                        viewport={{
                            once: true,
                            amount: .35,
                        }}
                    >
                        <TextWrapper>
                            <TitleLine className="white">추천 이벤트는<br/><LinePoint className="main-color">피드</LinePoint>로 빠르게 확인하세요
                            </TitleLine>
                            <SubLine className="white">실시간 인기 이벤트부터 당첨확률 높은 꿀이벤트까지<LineBreak className="mob"/> 만나보세요.&nbsp;<LineBreak className="pc"/>
                                피드를 보다보면 깜짝 선물을<LineBreak className="mob"/>&nbsp;발견할 수 있을지도?!</SubLine>
                        </TextWrapper>
                    </Contents>
                    <Contents
                        variants={videoContainerVariants}
                        initial="initial"
                        whileInView="animate"
                        viewport={{
                            once: true,
                            amount: .35,
                        }}
                    >
                        <VideoWrapper>
                            <BackgroundVideo
                                autoPlay
                                loop
                                muted
                                preload="none"
                                playsInline
                                aria-hidden="true"
                            >
                                <source
                                    src={
                                        window.matchMedia(mediaUnderTabletQuery).matches
                                            ? tabletVideoSrc
                                            : defaultVideoSrc
                                    }
                                    type="video/mp4"
                                />
                            </BackgroundVideo>
                        </VideoWrapper>
                    </Contents>
                </ContentsWrap>
            </Inner>
        </Section>
    );
}

export default FeedSectionView;

const Section = styled(OriginalSection)`
  position: relative;
  background: #111111;
`
const ContentsWrap = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  ${mediaTablet} {
    flex-flow: column;
    justify-content: flex-start;
    gap:50px;
  }
  ${mediaMaxWidthMobile} {
    gap:30px;
  }
  ${mediaMobile} {
    gap:unset;
  }
`;
const Contents = styled(motion.div)`
  &:nth-child(1) {
    position: absolute;
    left: 0;
    z-index: 2;
    ${mediaTablet} {
      position: relative;
      left: unset;
      top: unset;
    }
  }

  &:nth-child(2) {
    position: relative;
    width:100%;
    max-width: 915px;
    height: 1017px;
    ${mediaLaptop} {
      max-width: 652px;
      height: 725px;
      top: -50px;
      &::before{
        content: "";
        position: absolute;
        width:100%;
        height: 100px;
        background-image: linear-gradient(to top, rgba(17,17,17,0),rgba(17,17,17,1),rgba(17,17,17,1));
        top:-50px;
        left:0;
        right:0;
        margin: 0 auto;
        z-index: 1;
      }
      &::after{
        content: "";
        position: absolute;
        width:100%;
        height: 100px;
        background-image: linear-gradient(to bottom, rgba(17,17,17,0),rgba(17,17,17,1),rgba(17,17,17,1));
        bottom:-50px;
        left:0;
        right:0;
        margin: 0 auto;
        z-index: 1;
      }
    }
    ${mediaTablet} {
      max-width: 1035px;
      height: 835px;
      &::before{
        content: "";
        position: absolute;
        width:100%;
        height: 50px;
        background-image: linear-gradient(to top, rgba(17,17,17,0),rgba(17,17,17,1),rgba(17,17,17,1));
        top:-1px;
        left:0;
        right:0;
        margin: 0 auto;
        z-index: 1;
      }
      &::after{
        content: "";
        position: absolute;
        width:100%;
        height: 50px;
        background-image: linear-gradient(to bottom, rgba(17,17,17,0),rgba(17,17,17,1),rgba(17,17,17,1));
        bottom:-1px;
        left:0;
        right:0;
        margin: 0 auto;
        z-index: 1;
      }
    }
    ${mediaUnderTablet} {
      max-width:370px;
      height: 540px;
    }
    ${mediaMaxWidthMobile} {
      max-width:unset;
    }
  }
`;
const TextWrapper = styled.div`
  text-align: right;
  ${mediaTablet} {
    text-align: center;
  }
  ${mediaUnderTablet}{
    margin-top: 50px;
  }
`;